<template>

    <div class="map-container">
        <div class="customer">
            <v-avatar
                class="mr-15"
                :name="customer.initials"
                :color="customer.color"
                :url="customer.gravatar ? customer.gravatar + '&s=200' : ''"
                :size="88"
                :radius="44"
                :border="3">
            </v-avatar>
            <div class="pb-5">
                <div v-if="customer.name" class="name">{{ customer.name }}</div>
                <div v-else class="name">Unknown</div>
                <div class="traits">
                    <span v-if="customer.session">Last seen {{ customer.session.last_seen_at | relativeTime }}</span>
                    <span v-else>Not seen yet</span>
                    <span v-if="customer.email"><a :href="'mailto:' + customer.email">{{ customer.email }}</a></span>
                    <span v-if="customer.phone">{{ customer.phone }}</span>
                </div>
                <div v-if="customer.location" class="traits">
                    <span>{{ customer.location.display_name || 'Unknown Location' }}</span>
                </div>
            </div>
        </div>
        <v-identifier id="identifier" :uuid="customer.id" />
        <div id="map" :style="styles"></div>
    </div>

</template>

<style scoped lang="scss">

    .map-container {
        background-color: $color-bg;
        height: 200px;
        position: relative;
        width: 100%;
        .customer {
            align-items: center;
            bottom: 0;
            display: flex;
            left: 0;
            padding: 15px;
            position: absolute;
            z-index: 3;
            .name {
                @include font-semibold(24px);
                color: $color-text;
                line-height: normal;
            }
            .traits {
                @include font-medium(13px);
                color: $color-text;
                display: flex;
                line-height: 1.4em;
                margin-top: 5px;
                span {
                    margin-left: 5px;
                    &::before {
                        content: "•";
                        margin-right: 5px;
                    }
                    &:first-child {
                        margin: 0;
                        &::before {
                            display: none;
                        }
                    }
                }
                a {
                    color: $color-text;
                    text-decoration: none;
                    &:hover {
                        color: $color-primary;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    #identifier {
        margin: 10px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
    }

    #map {
        align-items: center;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        &::after {
            background: url('/img/pin.png');
            background-size: contain;
            content: "";
            height: 30px;
            position: relative;
            width: 30px;
            z-index: 1;
        }
    }

</style>

<script>

import queryString from 'query-string';

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    computed: {

        styles() {
            return this.url ? { 'background-image': `url('${this.url}')` } : '';
        },

        url() {
            let lat = this.customer.location?.lat;
            let lng = this.customer.location?.lng;
            if (lat && lng) {
                return `https://api.mapbox.com/styles/v1/sjwgroup/ckcsmxkn31z1r1iph5i6yolre/static/${lng},${lat},2.5,0,0/1280x200@2x?` + queryString.stringify({
                    access_token: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
                    attribution: false,
                    logo: false,
                });
            }
            return null;
        },

    },

}

</script>
